// extracted by mini-css-extract-plugin
export default {"flag":"mKypwPwQ49bXqHKMs04Q"};